export type ProductNavItem = {
  id: string;
  label: string;
  href: string;
  badge?: string;
};

export const productsNavLinks: ProductNavItem[] = [
  {
    id: 'signups',
    label: 'Sign Ups',
    href: '/sign-ups',
  },
  {
    id: 'payments',
    label: 'Sign Ups with Payments',
    href: '/payments',
  },
  {
    id: 'forms-waivers',
    label: 'Forms & Waivers',
    href: '/forms-and-waivers',
    badge: 'NEW',
  },
  // https://lumaverse.atlassian.net/browse/MAR-11151 - change Evnts to Tickets
  {
    id: 'events',
    label: 'Tickets',
    href: '/tickets',
    badge: 'NEW',
  },
  {
    id: 'fundraisers',
    label: 'Fundraisers',
    href: '/fundraisers',
    badge: 'NEW',
  },
  {
    id: 'dues-fees',
    label: 'Dues & Fees',
    href: '/dues-and-fees',
    badge: 'NEW',
  },
  {
    id: 'peer-to-peer-fundraisers',
    label: 'Peer-to-Peer Fundraisers',
    href: '/peer-to-peer-fundraisers',
    badge: 'NEW',
  },
  {
    id: 'online-stores',
    label: 'Online Stores',
    href: '/online-stores',
    badge: 'NEW',
  },
  {
    id: 'group-gifts',
    label: 'Group Gifts',
    href: '/group-gifts',
    badge: 'NEW',
  },
];
